/**
 * Created by Pactera on 2017/4/14.
 * 提交页面
 */
import { clearCost } from './modules/actions';
import Routes from 'Routes';
import { saveOldLocation } from '../../modules/actions';
import { gspCollect, gspNewVersion, isCsairApp } from '@csair/emp-helpers';
// import { toQueryString } from 'Utils';
import { loadStatusCodeMsg } from 'enEXchange';
import { compare } from 'Utils';

export default store => ({
  path: Routes.ticket.child.applySubmit.key,
  // onEnter(nextState, replace, callback) {
  //   const { orderNo, ticketNo } = nextState.location.query;
  //   const state = store.getState();
  //   if (
  //     state.App.oldLocation.pathname === Routes.ticket.child.endorsedApply.path ||
  //     state.App.oldLocation.pathname === Routes.ticket.child.ticketChange.path
  //   ) {
  //     callback();
  //   }
  // else if (orderNo !== null) {
  //   if (orderNo !== state.EdorsedApply.orderNo) {
  //     replace(
  //       `${Routes.ticket.child.updateDetail.path}?${toQueryString(state.updateDetail.urlQuery)}`,
  //     );
  //   }
  //   callback();
  // } else if (ticketNo !== null) {
  //   if (ticketNo !== state.EdorsedApply.ticketNo) {
  //     replace(
  //       `${Routes.ticket.child.updateDetail.path}?${toQueryString(state.updateDetail.urlQuery)}`,
  //     );
  //   }
  //   callback();
  // }
  // },
  onEnter(nextState, replace, callback) {
    loadStatusCodeMsg(['getNameAndPhone', 'change', 'getVerificationCode']);
    window.sessionStorage.removeItem('pageButtonName');
    const {
      App: { oldLocation },
      EdorsedApply: { changeProcess, flightList, psgList },
    } = store.getState();
    const { channel, flight, person } = nextState.location.query;

    const flightArr = flight.split(',').sort(compare);
    const personArr = person.split(',').sort(compare);

    let originSelectFlight = flightList.filter(
      (item, i) => flightArr.indexOf(String(i)) !== -1
    );
    let originSelectpsg = psgList.filter(
      (item, i) => personArr.indexOf(String(i)) !== -1
    );
    window.$sensors.sensors.track('flight_ticket_refund_and_change_page_view', {
      page_name: '机票退改-变更提交申请页',
      channel_id: channel ? channel : '',
      ticket_number: originSelectpsg.map(obj => obj.ticketNo).join(';'),
      flight_date: originSelectFlight.map(obj => obj.flightDate).join(';'),
      flight_number: originSelectFlight.map(obj => obj.flightNo).join(';'),
      origin_location: originSelectFlight
        .map(obj => obj.depAirportName)
        .join(';'),
      destination_location: originSelectFlight
        .map(obj => obj.arrAirportName)
        .join(';'),
      passenger_type: originSelectpsg
        .map(obj =>
          obj.psgType === 3
            ? '婴儿'
            : obj.psgType === 1 || obj.psgType === 2
            ? '儿童'
            : '成人'
        )
        .join(';'),
      ticket_refund_type:
        changeProcess && changeProcess[0] && changeProcess[0] === 'zybg'
          ? '自愿变更'
          : '非自愿变更',
    });
    window.sessionStorage.setItem('historyUrl', oldLocation.pathname);
    callback();
  },
  onLeave(prevState) {
    console.log('applysubmit route leave');
    store.dispatch(saveOldLocation(prevState.location));
  },
  getComponent(nextState, cb) {
    require.ensure(
      [],
      require => {
        store.dispatch(clearCost());
        const ApplySubmit = require('./components/ApplySubmit').default;
        cb(null, ApplySubmit);
      },
      'applySubmit'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/applySubmit/index.js